<template>
  <div class="home" :style="{'background-color': bgColor || '#fff'}">
    <van-sticky>
      <shareItem v-show="$route.query && ($route.query.sharetype =='browser')" :show="$route.query.preview" :dlurl="dlurl" pageCode="5010101" v-isNoAppShare/>
      <Top :contentPageId="contentPageId" :contentPageStyleVO="contentPageStyleVO" />
    </van-sticky>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
      <!-- <div style="padding-top: 60px;"></div> -->
      <div v-for="(item, index) in newList" :key="index" v-track:exposure :track-params="JSON.stringify(item)">
        <Swipe v-if="item.type == 1 && item.style == 4" :isExposure="!$route.query.linkId && !$route.query.preview" :backImage="contentPageStyleVO.carouselBgImageUrl" :contentPageId="contentPageId" :sort="index" :item="item" :Banner="item.itemList"/>
        <ImgItem pageCode="5010101" v-if="item.type == 1 && item.style != 4" :isExposure="!$route.query.linkId && !$route.query.preview" :contentPageId="contentPageId" :sort="index" :item="item" />
        <homepage v-if="item.type == 3" :contentPageId="contentPageId" :item="item" :sort="index" />
        <BranchAliads v-if="(item.type == 4 || item.type == 6) && refresh" :isLoading="isLoading" :contentPageId="contentPageId" :item="item" :sort="index" />
        <Seckill v-if="item.type == 5 && item.seckillActivityList && item.seckillActivityList.length > 0" :refresh="refresh" :contentPageId="contentPageId" :sort="index" :item="item" />
      </div>
      <!-- <homepage :homeIconList="homeIconList" /> -->
      <!-- <active :beessList="beess" :activityBanner="activityBanner" /> -->
      <comodityItem
        bg-color="background-color:#fff"
        :activity="activity"
        :goodssId="-1"
        :activeStatus="false"
        v-if="newList.length != 0"
        :refresh="refresh"
      />
      <!-- <goodsListWithPopup v-if="newList.length != 0" :refresh="refresh" /> -->
    </van-pull-refresh>
    <bombScreen pageCode="1"></bombScreen>
  </div>
</template>
<script>
import Top from "@/components/home/top";
import Swipe from "@/components/header/componets/swipe";
import homepage from "@/components/home/newIconPage";
import active from "@/components/home/active";
import comodityItem from "@/components/commodity/commodity/commodityitem";
import http from "@/utils/axios";
import bombScreen from "@/components/home/bombscreen";
import utils from "@/utils/common";
import Seckill from "@/components/home/seckill";
import ImgItem from "@/components/home/imgItem";
import BranchAliads from "@/components/home/branchAliads";
import GoodsListWithPopup from '@/components/commodity/commodity/goodsListWithPopup';
import shareItem from '@/views/shareDiscovery/components/shareBtn';
export default {
  data() {
    return {
      isLoading: false,
      show: false,
      banners: [],
      activity: {},
      beess: [],
      newList: [],
      bgColor: '',
      lurl:'',
      contentPageId: 0,
      seckillComponent: {},
      contentPageStyleVO: {},
      refresh: true
    }
  },
  methods: {
    onRefresh() {
      this.refresh = false;
      setTimeout(() => {
        this.isLoading = false;
        this.getNewData()
        document.querySelector("#app").scrollTop = 0;
      }, 1000);
    },
    getDate() {
      http({
        url: "/base/user/join/new/index",
        method: "post"
      }).then(rps => {
        if (rps.code === 200) {
          this.$loading.hide();
          this.banners = rps.data.banners;
          this.activityBanner = rps.data.activityBannerList;
          this.homeIconList = rps.data.homepageIconList;
          this.categoreis = rps.data.categoreis;
          this.beess = (rps.data && rps.data.beess) || [];
        }
      });
    },
    getNewData() { 
      let httpObj = {}
      let data = localStorage.getItem('homedata');
      let homedata = data && JSON.parse(data) || {}

      let { linkId, preview, dateTimeString, terminal, version ,type } = this.$route.query;
      if(linkId) {
        httpObj.url = 'order/admin/content-page/getContentPage/'+ linkId;
        httpObj.method = 'get';
      } else if(preview) {
        httpObj.url = 'order/admin/content-page/previewContentPage';
        httpObj.method = 'post';
        httpObj.parmes = {
          currentDateTimeString: dateTimeString,
          terminal,
          version,
          type
        }
      } else {
        httpObj.url = 'order/app/content-page/getHomeContentPageData';
        httpObj.method = 'post';
        httpObj.parmes = {
          contentPageId: homedata.id || '' ,
          updateTime: homedata.updateTime || 0 ,
          type:1
        }
      }
      
      this.$loading.show();
      http(httpObj).then(rps => {
        if(rps.code === 200) {
          window.isReloadNative =true;
          this.$loading.hide();
          if(rps.data.updated) {
            this.newList = rps.data.componentList;
            this.refresh = true;
            this.bgColor = rps.data.bgColor;
            this.contentPageId = rps.data.id;
            this.contentPageStyleVO = rps.data.contentPageStyleVO || {};
            localStorage.setItem('homedata', JSON.stringify(rps.data));
          } else {
            let { componentList, bgColor, id, contentPageStyleVO } = homedata;
            this.newList = componentList.map(item=>{
              if(item.type == 1 && item.configType == 2) {
                let adlist = rps.data.adComponentList.find(it => it.id == item.id)
                if(adlist) {
                  return Object.assign({}, item, adlist)
                }
                return item
              } else if(item.type == 5) {
                return Object.assign({}, item, rps.data.seckillComponent)
              }
              return item
            })
            this.refresh = true;
            this.bgColor = bgColor;
            this.contentPageId = id;
            this.contentPageStyleVO = contentPageStyleVO || {};
          }
          //秒杀每场排期多个商品情况下，都会有滚动 所以增加一个scrollBarPosition参数
          this.newList.forEach(item => {
            if(item.type == 5 && item.style == 7) {
              this.setCountDownParams(item)
            }
          })
          if(this.contentPageStyleVO.statusBarColorType) {
            if(window.isReloadNative){
              window.isReloadNative =false;
              utils.nativeMethod({tm: 1000003, tp:{isLight: this.contentPageStyleVO.statusBarColorType == 2}})
            }
          }
        }
      }).catch((e)=> {
        if(!e) {
          this.$loading.hide();
          this.$toast('网络异常，请重试！')
        }
      })
    },
    //设置秒杀样式二的一些参数
    setCountDownParams(item) {
      item.seckillActivityList.forEach(target => {
        const currentDate = new Date()
        const seckillStartDate = new Date(target.startTime.replace(/\-/g, '/')) //ios上 2020-10-01 10:10:10 这样会不生效，要替换成2020/10/01 10:10:10

        const oneHour = 60 * 60 * 1000
        const seconds = seckillStartDate.getTime() - currentDate.getTime()
        console.log(seckillStartDate.getTime(),currentDate.getTime())
        //距离当前场次一小时前显示倒计时
        if(seconds > 0 && seconds <= oneHour) {
          this.$set(target, 'visibleCountDown', true)
          this.$set(target, 'seconds', seconds)
        }
        this.$set(target, 'scrollBarPosition', 0)
        this.$set(target, 'started', target.type == 1 || target.type == 2) // 1 或 2 代表当前场次是开始
      })
    }
  },
  created() {
    this.$loading.hide();
    this.refresh = false;
    this.dlurl = this.$route.query.dlurl
    this.getNewData();
    utils.nativeMethod({ tm: "4000101", tp: { module_evar: "首页" } });
    utils.nativeMethod({ tm: "4000101", tp: { page_evar: "首页" } });
    utils.nativeMethod({
      tm: "4000102",
      tp: { pageName_pvar: document.title }
    });
    utils.nativeMethod({ tm: "4000102", tp: { pageType_pvar: "首页" } });
    window["refreshData"] = res => {
      
      this.onRefresh();
    };
    utils.nativeMethod({ tm: "4000003", tp: { key: "setUserInfo" } });
    window["setUserInfo"] = function(res) {
      let t = res;
      if (typeof res === "object") {
        t = JSON.stringify(t);
      }
      window.localStorage.setItem("userInfo", t);
    };
  },
  components: {
    Top,
    Swipe,
    homepage,
    active,
    comodityItem,
    bombScreen,
    Seckill,
    ImgItem,
    BranchAliads,
    GoodsListWithPopup,
    shareItem
  }
};
</script>
<style lang="less" scoped>
.home {
  background-color: #fff;
}
.index-index-tips {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 70px;
  padding: 0 80px;
}
.index-index-tips .tips {
  display: flex;
  align-items: center;
}
.index-index-tips .tips img {
  width: 28px;
  height: 28px;
}
.index-index-tips .tips span {
  font-size: 20px;
  padding-left: 10px;
}
</style>